import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { postRepatriationsTransactionsConfirmRequestActionCreator } from '../redux/actions/RepatriationsTransactionsConfirmActions';
import DATE_FORMATS from '../../../../../../common/models/constants/dateFormats';

class RepatriationsTransactionsConfirmQuantityConfirmDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: props.row.description,
      plannedArrivalDateTime: moment(props.row.plannedArrivalDateTime).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
      quantityConfirmed: props.row.quantityConfirmed,
      transactionId: props.row.transactionId,
    };
    this.confirm = this.confirm.bind(this);
  }

  async confirm() {
    await this.props.postRepatriationsTransactionsConfirmRequestActionCreator(
      this.props.appContext,
      this.state.description,
      this.state.plannedArrivalDateTime,
      this.state.quantityConfirmed,
      this.state.transactionId,
    );
    this.props.closeDialog();
    this.props.closeMainDialog();
    await this.props.refreshTransactions();
    this.props.refreshHistories();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Confirm New Quantity</DialogTitle>
        <div>
          <p style={{ padding: '5px' }}>Quantity confirmed is different from Executed quantity. Are you sure you want to confirm this change?</p>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirm}
            className="primary-button-false"
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

RepatriationsTransactionsConfirmQuantityConfirmDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  postRepatriationsTransactionsConfirmRequestActionCreator: PropTypes.func,
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  closeMainDialog: PropTypes.func,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postRepatriationsTransactionsConfirmRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RepatriationsTransactionsConfirmQuantityConfirmDialog);
